import { EnderecoSuper } from './endereco-super';
import { Endereco } from './endereco';
import { Construtor } from './construtor';

export class EnderecoPontoFisico extends EnderecoSuper implements Construtor<EnderecoPontoFisico> {

	public idEnderecoPontoFisico: number;
	public idPontoFisico: number;
	public selecionado: boolean;
	public alterado: boolean;

	constructor(object?: any) {
		super();
		this.endereco = new Endereco();
		if (object !== undefined && object !== null) {
			if (object instanceof EnderecoPontoFisico) {
				this.copyObject(object);
			} else if (object instanceof Endereco) {
				this.endereco = new Endereco(object);
			} else {
				this.parseFromJson(object);
			}

			if (!this.modeloCompleto()) {
				return null;
			}
		}
		return this;
	}

	copyObject(enderecoPontoFisico: EnderecoPontoFisico): void {
		this.idEnderecoPontoFisico = enderecoPontoFisico.idEnderecoPontoFisico;
		this.idPontoFisico = enderecoPontoFisico.idPontoFisico;
		this.Endereco = enderecoPontoFisico.endereco;
	}

	parseFromJson(enderecoPontoFisico: any): void {
		this.idEnderecoPontoFisico = enderecoPontoFisico.idEnderecoPontoFisico;
		this.endereco = enderecoPontoFisico.endereco;
		this.idPontoFisico = enderecoPontoFisico.idPontoFisico;
	}

	modeloCompleto(): boolean {
		return this.endereco.modeloCompleto();
	}

	getNewInstance(object?: any): EnderecoPontoFisico {
		return new EnderecoPontoFisico(object);
	}

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/endereco-ponto-fisico.ts